// extracted by mini-css-extract-plugin
export default {"statsContainer":"StatsPanel_statsContainer__V6okq","statsItem":"StatsPanel_statsItem__3Kl0r"};